<template>
    <div class="ats-panel">
        <div class="input-wrapper">
            <span class="char">W</span>
            <input
                v-model="mer"
                class="input"
                placeholder="MER"
                @keydown.enter="onEnter"
            >
            <span class="char">-</span>
            <input
                v-model="rge"
                class="input"
                placeholder="RGE"
                @keydown.enter="onEnter"
            >
            <span class="char">-</span>
            <input
                v-model="twp"
                class="input"
                placeholder="TWP"
                @keydown.enter="onEnter"
            >
            <span class="char">-</span>
            <input
                v-model="sec"
                class="input"
                placeholder="SEC"
                @keydown.enter="onEnter"
            >
            <span class="char">-</span>
            <input
                v-model="qtr"
                class="input"
                placeholder="QTR"
                @keydown.enter="onEnter"
            >
            <span class="char">-</span>
            <input
                v-model="lsd"
                class="input"
                placeholder="LSD"
                @keydown.enter="onEnter"
            >
            <span
                v-if="isClearable"
                class="mdi mdi-close cursor-pointer"
                @click="clearForm"
            />
            <span
                v-else
                class="mdi mdi-magnify"
                @click="onEnter"
            />
        </div>
        <ul class="instructions">
            <li>
                <span class="field"><strong>MER</strong> (Meridian)</span>
                <span class="desc">(West of the 4th, 5th or 6th)</span>
            </li>
            <li>
                <span class="field"><strong>RGE</strong> (Range)</span>
                <span class="desc">(1-30)</span>
            </li>
            <li>
                <span class="field"><strong>TWP</strong> (Township)</span>
                <span class="desc">(1-126)</span>
            </li>
            <li>
                <span class="field"><strong>SEC</strong> (Section)</span>
                <span class="desc">(1-36)</span>
            </li>
            <li>
                <span class="field"><strong class="optional">QTR</strong> (Quarter Section)</span>
                <span class="desc">Optional: (N, S, E, W, NW, SE, SW)</span>
            </li>
            <li>
                <span class="field"><strong class="optional">LSD</strong> (Legal Subdivision)</span>
                <span class="desc">Optional: (1-16)</span>
            </li>
        </ul>
        <div class="examples">
            <h3 class="title">
                Examples
            </h3>
            <p>W4-22-120-2-NW-2<br>W2-1-65-45<br>W4-22-120-2-NW-2<br>W2-1-65-45</p>
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
    name: 'SearchATSPanel',
    components: {},
    props: {
        handleSearch: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const mer = ref('');
        const rge = ref('');
        const twp = ref('');
        const sec = ref('');
        const qtr = ref('');
        const lsd = ref('');
        const isSearching = ref<boolean>(false);

        const isClearable = computed(() => isSearching.value);
        // mer.value.length
        // || rge.value.length
        // || twp.value.length
        // || sec.value.length
        // || qtr.value.length
        // || lsd.value.length
        // );

        const clearForm = () => {
            mer.value = '';
            rge.value = '';
            twp.value = '';
            sec.value = '';
            qtr.value = '';
            lsd.value = '';
            isSearching.value = false;
        };

        const onEnter = () => {
            if (!mer.value || !rge.value) {
                return;
            }
            isSearching.value = true;

            let query = `W${mer.value}-${rge.value}`;

            if (twp.value) {
                query = `${query}-${twp.value}`;
                if (sec.value) {
                    query = `${query}-${sec.value}`;
                    if (qtr.value) {
                        query = `${query}-${qtr.value}`;
                        if (lsd.value) {
                            query = `${query}-${lsd.value}`;
                        }
                    }
                }
            }

            clearForm();
            props.handleSearch(query);
        };

        return {
            mer,
            rge,
            twp,
            sec,
            qtr,
            lsd,
            isClearable,
            clearForm,
            onEnter
        };
    }
});
</script>

<style lang="postcss" scoped>
.ats-panel{
    @apply flex flex-row flex-wrap w-full p-4 bg-grey-200 overflow-hidden;

    .input-wrapper {
        @apply flex items-center w-full mb-4 text-sm;

        .char {
            @apply mx-1;
        }

        .input {
            @apply p-1;
            width: 75px;
        }

        .mdi {
            @apply text-xl ml-2;
            color: #878787;
        }
    }

    .instructions {
        @apply w-4/5 text-xs;

        .field, .desc {
            @apply inline-block w-2/5;
        }

        .desc {
            @apply w-3/5;
        }

        .optional {
            @apply text-grey-300;
        }
    }

    .examples {
        @apply w-1/5 text-xs text-grey-300;

        .title {
            @apply block text-sm font-bold text-black;
        }
    }
}
</style>
